/** Same-origin Tagdada brand assets — do not hotlink third-party CDNs (ISSUE-0023). */

/** Owner-provided transparent mark at frontend/public/ (true noBG RGBA). */
export const BRAND_LOGO_SRC = '/lpvvu5qb_Tagdada_icon_logo_upscaled_noBG.png';
